module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [(_vm.isSharedToYou) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('static.sharedWarehouse.notAllowed')))])])], 1) : _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "md": 8
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.adjustment.create.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('form.adjustment.basicInformation'),
      "name": "first"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.formBasicInformation,
      "translation": "form.adjustment",
      "hasLabel": true
    }
  }) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('v-products-table', {
    attrs: {
      "fields": _vm.fields,
      "page": "adjustment",
      "translation": "table.adjustment.products"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'inventory.adjustment.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.saveDraft
    }
  }, [_vm._v(_vm._s(_vm.$t('button.saveDraft').toUpperCase()))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v(_vm._s(_vm.$t('button.adjustment.completeAdjustment').toUpperCase()))]), _vm._v(" "), _c('el-button', {
    staticClass: "danger",
    attrs: {
      "loading": _vm.formBasicInformation.loading
    },
    on: {
      "click": _vm.deleteDraft
    }
  }, [_vm._v(_vm._s(_vm.$t('button.delete').toUpperCase()))])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4c7498e","hasScoped":false}!./src/app/pages/withNavigation/adjustment/stock/edit/edit.html
// module id = 3102
// module chunks = 1